import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/cc-discover': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M520.4 196.1c0 8.4-5.5 12.8-15.8 12.8h-4.7v-24.9h4.9c10.1 0 15.6 4.2 15.6 12.1zM528 32c26.5 0 48 21.5 48 48v352c0 26.5-21.5 48-48 48h-480c-26.5 0-48-21.5-48-48v-352c0-26.5 21.5-48 48-48h480zM483.9 170.9v82h16v-32.8h2.2l22.2 32.8h19.6l-25.8-34.4c12.1-2.5 18.7-10.6 18.7-23.2 0-28.5-30.3-24.4-52.9-24.4zM428 171v82h45.3v-13.8h-29.3v-22.2h28.3v-13.8h-28.3v-18.2h29.3v-14h-45.3zM359.3 171h-17.5l35 84.2h8.6l35.5-84.2h-17.5l-22.2 55.2zM303.4 168c-24.6 0-44.6 19.9-44.6 44.6 0 24.6 19.9 44.6 44.6 44.6 24.6 0 44.6-19.9 44.6-44.6 0-24.6-19.9-44.6-44.6-44.6zM254.1 174.1c-30.2-15-63.3 6.8-63.3 38 0 32.5 33.6 52.5 63.3 38.2v-19c-19.3 19.3-46.8 5.8-46.8-19.2 0-23.7 26.7-39.1 46.8-19v-19zM156.9 240.4c-7.6 0-13.8-3.7-17.5-10.8l-10.3 9.9c17.8 26.1 56.6 18.2 56.6-11.3 0-13.1-5.4-19-23.6-25.6-9.6-3.4-12.3-5.9-12.3-10.3 0-8.7 14.5-14.1 24.9-2.5l8.4-10.8c-19.1-17.1-49.7-8.9-49.7 14.3 0 11.3 5.2 17.2 20.2 22.7 25.7 9.1 14.7 24.4 3.3 24.4zM55.4 253c30.9 0 44.1-22.4 44.1-40.9 0-24.1-18-41.1-44.1-41.1h-23.4v82h23.4zM122.9 253v-82h-16v82h16zM544 433v-145c-33.3 20.8-226.4 124.4-416 160h401c8.2 0 15-6.8 15-15zM74.1 191.6c5.7 5 8.9 12.6 8.9 20.5 0 7.9-3.2 15.5-8.9 20.7-4.9 4.4-11.6 6.4-21.9 6.4h-4.2v-54.2h4.2c10.3 0 16.7 1.7 21.9 6.6z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/cc-discover.js
// module id = 747
// module chunks = 0